import { render, staticRenderFns } from "./ConfirmDisableBlock.vue?vue&type=template&id=15171100&scoped=true&"
import script from "./ConfirmDisableBlock.vue?vue&type=script&lang=js&"
export * from "./ConfirmDisableBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15171100",
  null
  
)

export default component.exports